<template>
	<div class="coverWrap">
		<div class="tryReadWrap">
			<!-- pc title -->
			<h3>{{tryTitle}}</h3>
			<!-- mobile title -->
			<div class="topPart">
				<div class="return" @click="TryReadReturn"></div>
				<h3>{{tryTitle}}</h3>
				<a href="https://m.tunnelling.cn/Manager/MemberIndex.aspx" v-if="isshowHeader"><img :src="imgUrl" alt="" /></a>
			</div>
			<!-- 消息框 -->
			<div class="messageWrap">
				<span><i class="el-icon-info"></i>现在正在试读章节，购买后可以阅读此章节全部内容</span>
				<a class="my-cart-box" @click="goToCartFn">购物车<i></i><span v-if="cartNum">{{ cartNum }}</span></a>
                <!-- <router-link to="/myCart" class="my-cart-box">购物车<i></i><span v-if="cartNum">{{ cartNum }}</span></router-link> -->
				<!-- 加入书单按钮 暂时弃用 -->
				<!-- 加入购物车 -->
				<!-- <span @click="BuyBookWay('cart',0)" class="pc_funBtn">加入书单</span> -->
				<!-- 直接购买 -->
				<!-- <span style="display: none;" @click="BuyBookWay('zj',0)" class="pc_funBtn">加入书单</span> -->
				<!-- 加入购物车 -->
				<!-- <span @click="GoBuyBookWay('cart',0)" class="mobile_funBtn">加入书单</span> -->
				<!-- 直接购买 -->
				<!-- <span style="display: none;" @click="GoBuyBookWay('zj',0)" class="mobile_funBtn">加入书单</span> -->
			</div>
			<div class="tryRead">
				<!--  :class="{'last-noallshow': isImgNoAllShow && index === tryReadList.length-1}" -->
				<div class="read-img" ref="getheight" v-for="(item,index) in tryReadList" :key="index"><img :src="item" alt="" /></div>
				<div class="overText"><span></span><span class="text">试读结束</span><span></span></div>
			</div>
			<!-- pc -->
			<div class="funBtn pc_funBtn">
				<!-- 直接购买 -->
				<p class="DirectPurchase" @click="BuyBookWay('zj',0)">直接购买</p>
				<!-- 加入购物车 -->
				<p class="nodisabledAdd addBooks" @click="BuyBookWay('cart',0)">加入书单</p>
				<!-- 纸质书二维码 -->
				<div class="ErHover" v-if="EwUrl || EwImgSrc">
					<a class="Qr-text" :href="EwUrl ? EwUrl : 'javascript:;'"><span></span>纸质书</a>
					<a class="Qr-img" v-if="EwImgSrc" :href="EwUrl ? EwUrl : 'javascript:;'"><img :src="EwImgSrc" /></a>
				</div>
				<!-- 加入购物车 -->
				<p class="nodisabledAll" v-if="!isVirtual" @click="BuyBookWay('cart',1)"><span></span>电子书全书</p>
			</div>
			<!-- mobile -->
			<div class="funBtn mobile_funBtn">
				<!-- 直接购买 -->
				<p class="DirectPurchase" @click="GoBuyBookWay('zj',0)">直接购买</p>
				<!-- 加入购物车 -->
				<p class="joinOrder" @click="GoBuyBookWay('cart',0)">加入书单</p>
				<!-- 加入购物车 -->
				<p class="allDownload" v-if="!isVirtual" @click="GoBuyBookWay('cart',1)"><span></span>电子书全书</p>
				<!-- 直接购买 -->
				<!-- <p class="allDownload" style="display: none;" @click="GoBuyBookWay('zj',1)"><span></span>电子书全书</p> -->
				<!-- 纸质书 -->
				<a v-if="EwUrl" :href="EwUrl" target="_blank"><span></span>纸质书</a>
			</div>
			<span @click="CloseTryRead"></span>
		</div>
		<!-- 加入购物车成功提示 -->
		<div v-if="showAddCartTip">
			<addCartSuccess :bookImgUrl="addCartInfo.imagePath" :bookTitle="addCartInfo.name" :chapterTitle="addCartInfo.informationTitle" />
		</div>
	</div>
</template>

<script>
import common from '../assets/js/common.js'
import addCartSuccess from './addCartSuccess.vue'
export default{
	data(){
		return{
			tryReadList:[],  // 情报url
			axiosApi:'',  // 域名
			tryReadPage:1,  // 试读页数
			isSell:undefined,  // 商品价格
			tryTitle:undefined,  // 试读标题
			imgUrl:'',  // 头像路径
			isshowHeader: true,  // 是否显示头像
			EwUrl: '',  // 二维码地址
			EwImgSrc: '',  // 二维码图片地址
			onlyOne: false,  // 章下面只有一节(mobile用)
			cartNum: 0,  // 购物车数量
			showAddCartTip: false,  // 加入购物车成功提示
			addCartInfo: {},  // tip信息
			isImgNoAllShow: false,  // 控制试读的最后一页是否显示完整
			isVirtual: false,  // 是否属于某本虚拟的书 true:属于 
			Remainder: 0  // 余数用来判断加载3分之1还是3分之2
		}
	},
	props:{
		// 情报内容id
		tryReadId:{
			type:Number,
			default:undefined
		},
		// 情报id
		InformationId:{
			type:Number,
			default:undefined
		},
		// 章id
		fatherId:{
			type:Number,
			default:undefined
		},
		// 章的第一节id
		firstChildId:{
			type:Number,
			default:undefined
		},
		// 当价格为-1时，此商品不能单独购买
		sellWay:{
			type:Number,
			default:undefined
		},
		// 是否为首页
		isIndex: {
			type: Boolean,
			default:false
		}
	},
	components: {
		addCartSuccess
	},
	created() {
		this.GetUserInfo();
		this.GetTryReadInfo();
	},
	mounted() {
		this.axiosApi = Const_Api_Root;
		// 关闭加入成功提示
		common.$on('closeTip', () => {
			this.showAddCartTip = false
			// 获取购物车数量
			this.getCartNumFn();
		})
	},
	methods:{
        // 跳转到购物车
        goToCartFn() {
            if(this.isshowHeader) {
                this.$router.push('/myCart');
                return;
            }

            let nowHref = `${Const_Api_Root}/#/myCart`;
            let href = 'https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=' + encodeURIComponent(nowHref);
            location.href = href;
        },
		// 获取用户信息
		GetUserInfo(){
			this.$fetch('/Login')
			.then((res)=>{
				if(res.data.accessAllowed === false){
					this.isshowHeader = false;
					return;
				}
				this.imgUrl = res.data.imagePath;
				
				// 获取购物车数量
				this.getCartNumFn()
			}).catch((err)=>{
				throw err;
			});
		},
		// 获取购物车数量
		getCartNumFn() {
			this.$fetch('/api/ShoppingCarts/count').then(res => {
				this.cartNum = res.data.count
			}).catch(err => {
				throw err;
			})
		},
		// 获取试读信息
		GetTryReadInfo(){
			this.$fetch('/api/information/'+this.InformationId+'/informationContent/'+this.tryReadId)
			.then((res)=>{
				this.tryReadPage = res.data.tryReadingPages;
				// 是对 章下面只有一节，而且现价不为-1按照 节不单独卖 来操作
				if(res.data.parent && res.data.parent.subChapterCount === 1){
				  this.isSell = -1;
				  this.onlyOne = true;
				}else{
				  this.isSell = res.data.currentPrice;
				}
				this.tryTitle = res.data.title;
				this.EwUrl = res.data.bookStoreUrl;
				this.EwImgSrc = res.data.bookStoreQR;
				this.isVirtual = res.data.isVirtual
				if(res.data.purchased){
					this.JudgeIsPurchased();
				}
				this.GetTryRead(res.data.pageCount);
			}).catch((err)=>{
				throw err;
			});
		},
		// 获取试读
		GetTryRead(pageCount){
			// 试读内容：本节的3/1
			let imgNum = pageCount / 3;
			this.Remainder = pageCount % 3
			// 判断图片是否显示完整
			this.isImgNoAllShow = imgNum % 1 === 0 ? false : true
			
			let page = 0;
			for(let i=0;i<this.tryReadPage;i++){
				page++;
				this.tryReadList.push(this.axiosApi+'/api/TryReading/'+this.tryReadId+'?pageIndex='+page);
			}
			setTimeout(() => {
				this.$nextTick(()=> {
					this.TryReadLastimg()
				})
			}, 1000)
		},
		// 控制最后一张图片显示部分
		TryReadLastimg(){
			let imgBoxDom = this.$refs['getheight'], len = imgBoxDom.length - 1
			if(this.isImgNoAllShow){
				this.Remainder === 2 ? imgBoxDom[len].style.height = imgBoxDom[len].firstChild.clientHeight/3*2+'px' : imgBoxDom[len].style.height = imgBoxDom[len].firstChild.clientHeight/3+'px'
				imgBoxDom[len].style.overflow = 'hidden'
			}
		},
		// 判断是否已购
		JudgeIsPurchased(){
			this.$confirm('您刚才选择试读的是已购内容，可直接去阅读。', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$router.push({
					path: '/bookRead',
					query: {
						InformationId:this.InformationId,
						id: this.tryReadId
					}
				});
			}).catch(() => {
				this.$router.push({
					path: '/bookDetail',
					query: {
						InformationId:this.InformationId
					}
				});
			});
		},
		// 购买方式
		BuyBookWay(isCart,type){
			this.$fetch('/Login').then((res)=>{
				// 判断登陆状态
				if(res.data.accessAllowed === false){
					this.LoginTipFn();
					return;
				}
				let txtTip = 0,
					type_ = type;
				// 如果当前节为不可卖,点击时就会买章or书
				if(this.isSell == -1 && type == 0) {
					if(this.sellWay == 0){
						this.tryReadId = this.fatherId;
					}else{
						type_ = this.sellWay;
					}
					txtTip = -1;
				}
				// 目录页触发
				common.$emit('buyBook',isCart,type_,txtTip,this.tryReadId,this.firstChildId);
			}).catch((err)=>{
				throw err;
			});
		},
		// mobile-去支付
		GoBuyBookWay(isCart,type){
			this.$fetch('/Login')
			.then((res)=>{
				// 判断登陆状态
				if(res.data.accessAllowed === false){
					this.LoginTipFn('mobile');
					return;
				}
				
				let txtTip = 0,
					type_ = type,
					cId = this.tryReadId;
				if(this.isSell == -1 && type == 0) {
					if(this.sellWay == 0){
						this.tryReadId = this.fatherId;
					}else{
						// 当只有节又不能单独卖时，这时type要为sellway的值
						type_ = this.sellWay;
					}
					txtTip = -1;
				}
				if(type_ == 1){
					cId = sessionStorage.getItem('firstPurchasedId');
				}
				
				// 加入购物车方式 获取商品id
				if(isCart === 'cart') {
					this.mobileBuyBookWay(type_,txtTip,this.tryReadId,this.firstChildId)
					return
				}
				
				// 跳转
				this.$router.push({
					name: "BookPayment",
					query: {
						type:type_,
						InformationId:this.InformationId,
						id:this.tryReadId,
						chapterId:cId,
						sellway:txtTip
					}
				});
			}).catch((err)=>{
				throw err;
			});
		},
		// 判断是否登录
		LoginTipFn(type){
			this.$confirm('此操作需登录后进行，是否继续？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// this.isIndex 代表是在首页试读
				let nowHref = this.isIndex ? `${location.href}?InformationId=${this.InformationId}` : `${location.href}`
				if(type !== 'mobile'){
					if(this.isSell == -1 && this.sellWay == 0){
						nowHref = nowHref+'&sellWay='+this.sellWay+'&fatherId='+this.fatherId+'&firstChildId='+this.firstChildId+'&tryReadId='+this.tryReadId+'&isPopup=true';
					}else{
						nowHref = nowHref+'&sellWay='+this.sellWay+'&tryReadId='+this.tryReadId+'&isPopup=true';
					}
				}
				let href = 'https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=' + encodeURIComponent(nowHref);
				location.href = href;
			}).catch(() => {});
		},
		// 关闭试读
		CloseTryRead(){
			common.$emit('closeRead');
		},
		// 返回
		TryReadReturn(){
			if(this.isIndex) {
				this.$router.push('/index');
				return
			}
			
			this.$router.push({
				path: '/bookDetail',
				query: {
					InformationId:this.InformationId
				}
			});
		},
		// 移动端加入购物车所需支付方式
		mobileBuyBookWay(type, issell, chapterId, firstchildId) {
			// 加入购物车方式
			if(issell === -1) {
				this.$confirm('您选择试读的文章无法单独加入书单，所以将选择其所在章（书）加入，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (type == 0) {
						this.mobileGetSingleGoods(chapterId);
					} else if (type == 1) {
						this.MobileGetGoods();
					}
				}).catch(() => {});
			}else {
				if (type == 0) {
					this.mobileGetSingleGoods(chapterId);
				} else if (type == 1) {
					this.MobileGetGoods();
				}
			}
		},
		// 获取单个商品
		mobileGetSingleGoods(id) {
			this.$fetch('/api/information/' + this.InformationId + '/informationContent/goods/?id=' + id)
				.then((res) => {
					// 商品信息
					this.addCartInfo = res.data
					// 加入购物车
					this.mobileAddToCartFn(res.data.id)
				}).catch((err) => {
					throw err;
				});
		},
		// 加入购物车
		mobileAddToCartFn(goodsId) {
			this.$post('/api/ShoppingCarts', {'goodsId': goodsId}).then(res => {
				// 获取购物车数量
				this.getCartNumFn();
				// 提示
				this.showAddCartTip = true
			}).catch(err => {
				this.$message({
					message: '该内容已经在您的购物车内了',
					type: 'error',
					offset: 100
				});
				throw err
			})
		},
		// 获取整个情报商品
		MobileGetGoods() {
			this.$fetch('/Login')
				.then((res) => {
					// 判断登陆状态
					if (res.data.accessAllowed === false) {
						this.LoginTipFn();
						return;
					}
		
					this.$fetch('/api/information/goods/?id=' + this.InformationId)
						.then((res) => {
							// 商品信息
							this.addCartInfo = res.data
							// 加入购物车
							this.mobileAddToCartFn(res.data.id)
						}).catch((err) => {
							throw err;
						});
				}).catch((err) => {
					throw err;
				});
		}
	}
}
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
	.coverWrap{
		width: 100%;
		height: 100%;
		/* height: calc(100% - .88rem); */
	}
	/* 返回 */
	.topPart{
		width: 100%;
		height: .88rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
	}
	.topPart img{
		width: .6rem;
		height: .6rem;
		border-radius: 50%;
		margin-right: .25rem;
	}
	.topPart .return{
		width: .4rem;
		height: .4rem;
		background: url(../assets/img/return_mobile.svg) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		left: .25rem;
		top: 50%;
		transform: translateY(-50%);
	}
	.topPart h3{
		margin-left: .73rem;
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	/* 关闭 */
	.tryReadWrap>span,.pc_funBtn,.tryReadWrap>h3{
		display: none !important;
	}
	/* 消息框 */
	.messageWrap{
		width: 100%;
		height: .6rem;
		background: #2468F2;
		font-size: .22rem;
		color: #FFFFFF;
		padding: 0 .1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.messageWrap i{
		margin-right: .1rem;
	}
	.messageWrap .mobile_funBtn{
		height: .3rem;
		line-height: .3rem;
		padding: 0 .07rem;
		background-color: #FFFFFF;
		font-size: .2rem;
		color: #2468F2;
		letter-spacing: 0;
	}
	/* 内容 */
	.tryReadWrap{
		display: flex;
		flex-direction: column;
		height: 100%;
	}
	.tryReadWrap .tryRead{
		width: 100%;
		flex: 1;
		margin: 0 auto;
		overflow: hidden;
		overflow-y: auto;
	}
	.tryReadWrap .tryRead .read-img {
		width: 100%;
	}
	.tryReadWrap .tryRead .read-img img{
		width: 100%;
		height: auto;
	}
	.tryReadWrap .tryRead .last-noallshow {
		width: 100%;
		height: 50%;
		overflow: hidden;
	}
	/* 试读结束 */
	.overText{
		font-size: .24rem;
		color: #CCCCCC;
		line-height: .24rem;
		width: 100%;
		padding: 0 .25rem;
		height: .4rem;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.overText span:first-child,.overText span:last-child{
		display: inline-block;
		flex: 1;
		height: 1px;
		background: #EEEEEE;
	}
	.overText .text{
		margin: 0 .2rem;
	}
	/* 加入书单 */
	.tryReadWrap .funBtn{
		display: flex;
		justify-content: center;
		align-items: center;
		margin: .5rem 0 1.3rem;
	}
	.funBtn p,.funBtn a{
		padding: .08rem .22rem;
		font-size: .24rem;
		border-radius: .24rem;
	}
	.funBtn p:nth-child(2){
		margin: 0 .44rem;
	}
	.allDownload{
		background: #2468F2;
		color: #FFFFFF;
		margin-right: .44rem;
	}
	.joinOrder{
		background: #FF7B5B;
		color: #FFFFFF;
	}
	.mobile_funBtn a{
		border: 1px solid #2468F2;
		color: #2468F2;
	}
	.DirectPurchase {
		background: #FFEEE9;
		border-radius: .22rem;
		border: 1px solid #EF8264;
		color: #EF8264;
	}
	/* 购物车 */
	.my-cart-box {
		color: #FFFFFF;
		font-size: .24rem;
		position: relative;
	}
	.my-cart-box i {
		display: inline-block;
		vertical-align: middle;
		background: url(../assets/img/MyCart_pc.png) no-repeat center center;
		background-size: 100% 100%;
		width: 20px;
		height: 20px;
		margin-top: -4px;
		margin-right: .2rem;
	}
	
	.my-cart-box span {
		display: inline-block;
		width: 20px;
		height: 14px;
		line-height: 14px;
		background: #DB3838;
		border-radius: 27px;
		color: #FFFFFF;
		font-size: 10px;
		text-align: center;
		position: absolute;
		top: -6px;
		right: -2px;
	}
}
@media screen and (min-width: 1445px) {
	.mobile_funBtn,.topPart{
		display: none !important;
	}
	.coverWrap{
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.40);
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
	}
	/* 试读 */
	.tryReadWrap{
		width: 860px;
		height: 90%;
		background: #FFFFFF;
		text-align: center;
		position: relative;
	}
	/* 关闭 */
	.tryReadWrap>span{
		width: 25px;
		height: 25px;
		cursor: pointer;
		background: url(../assets/img/signOutBtn.svg) no-repeat;
		background-size: 100%;
		position: absolute;
		top: 8px;
		right: 15px;
	}
	/* 标题 */
	.tryReadWrap>h3{
		padding: 10px 45px;
		font-size: 14px;
		color: #333333;
		background: #F5F5F5;
		/* overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding: 0 40px; */
	}
	/* 消息框 */
	.messageWrap{
		width: 70%;
		line-height: 40px;
		margin: 10px auto 0;
		background: #2468F2;
		border-radius: 4px;
		font-size: 14px;
		color: #FFFFFF;
		padding: 0 16px;
		display: flex;
		justify-content: space-between;
	}
	.messageWrap i{
		margin-right: 8px;
	}
	.messageWrap span:nth-child(2){
		cursor: pointer;
	}
	/* 内容 */
	.tryReadWrap .tryRead{
		width: 80%;
		height: 80%;
		margin: 0 auto 10px;
		overflow: hidden;
		overflow-y: auto;
	}
	.tryReadWrap .tryRead .read-img {
		width: 100%;
	}
	.tryReadWrap .tryRead .read-img img{
		width: 100%;
		height: auto;
	}
	.tryReadWrap .tryRead .last-noallshow {
		width: 100%;
		height: 475px;
		overflow: hidden;
	}
	/* 试读结束 */
	.overText{
		font-size: 14px;
		color: #CCCCCC;
		text-align: center;
		width: 80%;
		height: 40px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.overText span:first-child,.overText span:last-child{
		display: inline-block;
		width: 40%;
		height: 1px;
		background: #EEEEEE;
	}
	.overText .text{
		margin: 0 20px;
	}
	/* 加入书单 */
	.tryReadWrap .funBtn{
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 15px 0 0;
	}
	.funBtn>a{
		font-size: 16px;
		letter-spacing: 0.69px;
		line-height: 16px;
		padding: 10px 20px;
	}
	.funBtn a span{
		display: inline-block;
		width: 20px;
		height: 20px;
		vertical-align: middle;
		margin-right: 6px;
	}
	.funBtn a span{
		background:  url(../assets/img/detailsPaper_icon.svg) no-repeat;
	}
	.funBtn .addBooks{
		border-radius: 4px;
		width: 176px;
		line-height: 40px;
		font-size: 14px;
		color: #FFFFFF;
		letter-spacing: 0;
	}
	.funBtn>a{
		margin: 0 20px;
		color: #424242;
		background: #dcdfe6;
		margin-right: 30px;
	}
	.tryReadWrap .funBtn a{
		border-radius: 4px;
	}
	/* 直接购买 */
	.DirectPurchase {
		width: 128px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #FFEEE9;
		border-radius: 4px;
		border: 1px solid #EF8264;
		font-size: 14px;
		color: #EF8264;
		margin-right: 20px;
		cursor: pointer;
	}
	/* 禁用 */
	.nodisabledAdd{
		background: #FF7B5B;
		cursor: pointer;
		margin-right: 20px;
	}
	.nodisabledAll{
		background: #dcdfe6;
		cursor: pointer;
		color: #424242;
		border-radius: 4px;
		font-size: 16px;
		letter-spacing: 0.69px;
		line-height: 16px;
		padding: 10px 20px;
	}
	.nodisabledAll span{
		display: inline-block;
		width: 20px;
		height: 20px;
		vertical-align: middle;
		margin-right: 6px;
		background: url(../assets/img/detailsTryRead_icon.svg) no-repeat;
	}
	.disabledBtn{
		border: 1px solid #ebebeb;
		color: #ccc !important;
		background-color: #f7f7f7;
		cursor: not-allowed;
		font-weight: 700;
	}
	/* 纸质书 */
	.ErHover .Qr-text {
		display: block;
		border-radius: 4px;
		color: #424242;
		background: #dcdfe6;
		font-size: 16px;
		letter-spacing: 0.69px;
		line-height: 16px;
		padding: 10px 20px;
		margin-right: 20px;
	}
	.ErHover .Qr-img {
		display: none;
		position: absolute;
		top: -520px;
		left: -220px;
		width: 550px;
		height: auto;
		z-index: 9999;
		border: 1px solid #ccc;
	}
	.ErHover .Qr-img img {
		width: 100%;
		height: auto;
	}
	.ErHover{
		position: relative;
	}
	.ErHover:hover .Qr-img {
		display: block !important;
	}
	/* 购物车 */
	.my-cart-box {
		color: #FFFFFF;
		font-size: 16px;
		position: relative;
	}
	.my-cart-box i {
		display: inline-block;
		vertical-align: middle;
		background: url(../assets/img/MyCart_pc.png) no-repeat center center;
		background-size: 100% 100%;
		width: 20px;
		height: 20px;
		margin-top: -4px;
	}
	.my-cart-box span {
		display: inline-block;
		width: 20px;
		height: 14px !important;
		line-height: 14px !important;
		text-align: center;
		background: #DB3838;
		border-radius: 7px;
		font-size: 10px;
		position: absolute;
		top: 6px;
		right: -5px;
	}
}
@media screen and (min-width: 1029px) and (max-width: 1440px) {
	.mobile_funBtn,.mobile_funBtn,.topPart{
		display: none !important;
	}
	.coverWrap{
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.40);
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
	}
	/* 试读 */
	.tryReadWrap{
		width: 860px;
		height: 90%;
		background: #FFFFFF;
		text-align: center;
		position: relative;
	}
	/* 关闭 */
	.tryReadWrap>span{
		width: 25px;
		height: 25px;
		cursor: pointer;
		background: url(../assets/img/signOutBtn.svg) no-repeat;
		background-size: 100%;
		position: absolute;
		top: 6px;
		right: 10px;
	}
	/* 标题 */
	.tryReadWrap>h3{
		font-size: 14px;
		color: #333333;
		background: #F5F5F5;
		padding: 10px 40px;
		/* overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding: 0 40px; */
	}
	/* 消息框 */
	.messageWrap{
		width: 80%;
		line-height: 30px;
		margin: 10px auto 0;
		background: #2468F2;
		border-radius: 4px;
		font-size: 14px;
		color: #FFFFFF;
		padding: 0 16px;
		display: flex;
		justify-content: space-between;
	}
	.messageWrap i{
		margin-right: 8px;
	}
	.messageWrap span:nth-child(2){
		cursor: pointer;
	}
	/* 内容 */
	.tryReadWrap .tryRead{
		width: 80%;
		height: 80%;
		margin: 0 auto 10px;
		overflow: hidden;
		overflow-y: auto;
	}
	.tryReadWrap .tryRead .read-img {
		width: 100%;
	}
	.tryReadWrap .tryRead .read-img img{
		width: 100%;
		height: auto;
	}
	.tryReadWrap .tryRead .last-noallshow {
		width: 100%;
		height: 475px;
		overflow: hidden;
	}
	/* 试读结束 */
	.overText{
		font-size: 14px;
		color: #CCCCCC;
		text-align: center;
		width: 80%;
		height: 40px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.overText span:first-child,.overText span:last-child{
		display: inline-block;
		width: 37%;
		height: 1px;
		background: #EEEEEE;
	}
	.overText .text{
		margin: 0 20px;
	}
	/* 加入书单 */
	.tryReadWrap .funBtn{
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 5px 0 0;
	}
	.funBtn>a{
		font-size: 16px;
		letter-spacing: 0.69px;
		line-height: 16px;
		padding: 10px 20px;
	}
	.funBtn a span{
		display: inline-block;
		width: 20px;
		height: 20px;
		vertical-align: middle;
		margin-right: 6px;
	}
	.funBtn a span{
		background:  url(../assets/img/detailsPaper_icon.svg) no-repeat;
	}
	.funBtn .addBooks{
		border-radius: 4px;
		width: 176px;
		line-height: 40px;
		font-size: 14px;
		color: #FFFFFF;
		letter-spacing: 0;
	}
	.funBtn>a{
		margin: 0 20px;
		color: #424242;
		background: #dcdfe6;
		margin-right: 30px;
	}
	.tryReadWrap .funBtn>a{
		border-radius: 4px;
	}
	/* 直接购买 */
	.DirectPurchase {
		width: 128px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #FFEEE9;
		border-radius: 4px;
		border: 1px solid #EF8264;
		font-size: 14px;
		color: #EF8264;
		margin-right: 20px;
		cursor: pointer;
	}
	/* 禁用 */
	.nodisabledAdd{
		background: #FF7B5B;
		cursor: pointer;
		margin-right: 20px;
	}
	.nodisabledAll{
		background: #dcdfe6;
		cursor: pointer;
		border-radius: 4px;
		color: #424242;
		font-size: 16px;
		letter-spacing: 0.69px;
		line-height: 16px;
		padding: 10px 20px;
	}
	.nodisabledAll span {
		display: inline-block;
		width: 20px;
		height: 20px;
		vertical-align: middle;
		margin-right: 6px;
		background: url(../assets/img/detailsTryRead_icon.svg) no-repeat;
	}
	.disabledBtn{
		border: 1px solid #ebebeb;
		background-color: #f7f7f7;
		cursor: not-allowed;
		font-weight: 700;
		color: #ccc !important;
	}
	/* 纸质书 */
	.ErHover .Qr-text {
		display: block;
		border-radius: 4px;
		color: #424242;
		background: #dcdfe6;
		font-size: 16px;
		letter-spacing: 0.69px;
		line-height: 16px;
		padding: 10px 20px;
		margin-right: 20px;
	}
	.ErHover .Qr-img {
		display: none;
		position: absolute;
		top: -520px;
		left: -220px;
		width: 550px;
		height: auto;
		z-index: 9999;
		border: 1px solid #ccc;
	}
	.ErHover .Qr-img img {
		width: 100%;
		height: auto;
	}
	.ErHover{
		position: relative;
	}
	.ErHover:hover .Qr-img{
		display: block !important;
	}
	/* 购物车 */
	.my-cart-box {
		color: #FFFFFF;
		font-size: 12px;
		position: relative;
	}
	.my-cart-box i {
		display: inline-block;
		vertical-align: middle;
		background: url(../assets/img/MyCart_pc.png) no-repeat center center;
		background-size: 100% 100%;
		width: 20px;
		height: 20px;
		margin-top: -4px;
	}
	.my-cart-box span {
		display: inline-block;
		width: 20px;
		height: 14px !important;
		line-height: 14px !important;
		text-align: center;
		background: #DB3838;
		border-radius: 7px;
		font-size: 10px;
		position: absolute;
		top: 1px;
		right: -5px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/TryRead.vue